import { forwardRef, type HTMLAttributes } from 'react'
import { cn } from '@/lib/utils'

/**
 * Toolbar — панель инструментов (`.toolbar` макета): группа контролов в строку с переносом.
 * Отступы/выравнивание из токенов; порядок обхода фокусом сохраняется.
 */
export const Toolbar = forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement>>(
  ({ className, role, ...props }, ref) => {
    // role="toolbar" требует доступного имени (ARIA 1.2). Применяем роль только когда оно задано
    // (aria-label/aria-labelledby) или роль передана явно — иначе остаёмся обычным контейнером.
    const hasName = props['aria-label'] != null || props['aria-labelledby'] != null
    return (
      <div
        ref={ref}
        role={role ?? (hasName ? 'toolbar' : undefined)}
        className={cn('mb-4 flex flex-wrap items-center gap-2.5', className)}
        {...props}
      />
    )
  },
)
Toolbar.displayName = 'Toolbar'
